import axios, { Method, AxiosHeaders } from 'axios';
import { message } from 'antd';
import { R as BaseResult } from '@/services/type';
import { DECRYPT_KEY, LOGIN_PAGE } from './constant';

export const controllers: AbortController[] = [];

export const QUIT_LOGIN_CODE = [401, '401'];

const DEFAULT_AXIOS_TIMEOUT = 15000;

export const instance = axios.create({
  timeout: DEFAULT_AXIOS_TIMEOUT,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['satoken'] = token;
  }

  // 继续下单返回值、app bol详情不需要加密
  if (['/api/order/detail', '/api/order/detail-special'].includes(config.url!)) {
    config.headers[DECRYPT_KEY] = 'true';
  } else {
    config.headers[DECRYPT_KEY] = localStorage.getItem(DECRYPT_KEY) ?? 'false';
  }

  config.headers['Content-Type'] = 'application/json';
  return config;
});

enum API_CODE {
  SUCCESS = 0,
}

function createFormData<F>(forData: F): FormData | null {
  if (!forData) {
    return null;
  }
  const data = new FormData();
  Object.entries(forData).forEach(([name, value]) => {
    data.append(name, value as string);
  });
  return data;
}

function pathReplace<P>(url: string, path: P): string {
  if (!path) {
    return url;
  }
  let nextApi = url;
  Object.entries(path).forEach(([name, value]) => {
    const encodedValue = encodeURIComponent(value + '');
    nextApi = nextApi.replace(`{${name}}`, encodedValue);
  });
  return nextApi;
}

export default async function request<P, Q, B, H extends AxiosHeaders | null, F, R>(
  method: Method,
  url: string,
  path: P,
  query: Q,
  body: B,
  headers: H,
  formData: F,
): Promise<BaseResult<R> & R> {
  const controller = new AbortController();
  controllers.push(controller);

  try {
    const response = await instance({
      method,
      // @ts-expect-error eslint-disable-next-line
      // eslint-disable-next-line
      url: `${API_PREFIX || ''}${pathReplace(url, path)}`,
      params: query,
      data: body || createFormData(formData),
      headers: headers || undefined,
      signal: controller.signal,
    });
    const data = response.data as BaseResult<R> & R;
    if (data.code !== API_CODE.SUCCESS) {
      message.error({
        className: 'error-message',
        content: data?.msg,
        duration: 2,
        onClose() {
          if (data.code !== undefined && QUIT_LOGIN_CODE.includes(data.code)) {
            location.href = LOGIN_PAGE;
          }
        },
      });
    }
    return data;
  } catch (error) {
    console.error(error);
    return { code: -1 } as BaseResult<R> & R;
  } finally {
    const index = controllers.indexOf(controller);
    if (index > -1) {
      controllers.splice(index, 1);
    }
  }
}
